module.exports = __webpack_public_path__ + "static/candle-steps-zoom-28c124660d7719325160392e9286b99f.jpg";